import { useCallback } from 'react';
import { ToastFeature } from './types';
import { DEAFULT_OPTIONS } from './const';
import { useToastManager } from './useToastManager';

export const useToast = () => {
  const manager = useToastManager();
  return useCallback<ToastFeature>(
    (type, content, options) => {
      const id = manager.create({ type, content, ...DEAFULT_OPTIONS, ...options });
      return () => {
        if (id) {
          manager.close(id);
        }
      };
    },
    [manager],
  );
};
